import { Box, Typography, Stack, Chip } from "@mui/material";
import { useTranslation } from "utils/locales/utilityFunctions";

import { styles } from "../styles";

type AIEmptyStateProps = {
  onSendMessage: (message: string) => void;
  suggestions: string[];
}
export function AIEmptyState({ onSendMessage, suggestions }: AIEmptyStateProps) {
  const { translate } = useTranslation();

  return (
    <Box sx={styles.empty}>
      <Typography sx={{ fontWeight: 600 }}>
        {translate("ai-chat-empty-title")}
      </Typography>

      <Stack spacing={1} mt={2}>
        {suggestions.map((key) => (
          <Chip key={key} label={translate(key)} clickable onClick={() => onSendMessage(translate(key))} />
        ))}
      </Stack>
    </Box>
  );
}